import { forwardRef } from 'react';
import './PixelDaniel.css';

export type AnimationState =
  | 'idle'
  | 'walking'
  | 'waving'
  | 'pointing'
  | 'surprised'
  | 'riding'
  | 'pushing'
  | 'sleeping'
  | 'sipping';

export type Direction = 'left' | 'right';

interface PixelDanielProps {
  animation?: AnimationState;
  direction?: Direction;
  className?: string;
  onClick?: () => void;
  wearingHardhat?: boolean;
}

const PixelDaniel = forwardRef<HTMLDivElement, PixelDanielProps>(
  ({ animation = 'idle', direction = 'right', className = '', onClick, wearingHardhat = false }, ref) => {
    return (
      <div
        ref={ref}
        className={`pixel-daniel ${animation} ${direction} ${className} ${wearingHardhat ? 'construction' : ''}`}
        onClick={onClick}
        aria-hidden="true"
      >
        <div className="daniel-container">
          {/* Construction Hardhat (shown when wearingHardhat) */}
          {wearingHardhat && (
            <div className="hardhat">
              <div className="hardhat-dome"></div>
              <div className="hardhat-brim"></div>
            </div>
          )}

          {/* Hair (hidden when wearing hardhat) */}
          <div className={`hair ${wearingHardhat ? 'hidden' : ''}`}>
            <div className="hair-wave hair-wave-1"></div>
            <div className="hair-wave hair-wave-2"></div>
            <div className="hair-wave hair-wave-3"></div>
          </div>

          {/* Head */}
          <div className="head">
            {/* Eyes */}
            <div className="eye eye-left">
              <div className="pupil"></div>
            </div>
            <div className="eye eye-right">
              <div className="pupil"></div>
            </div>

            {/* Eyebrows */}
            <div className="eyebrow eyebrow-left"></div>
            <div className="eyebrow eyebrow-right"></div>

            {/* Mouth */}
            <div className="mouth"></div>
          </div>

          {/* Body / Shirt */}
          <div className="body">
            <div className="shirt-pattern"></div>
            <div className="collar collar-left"></div>
            <div className="collar collar-right"></div>
            {/* Safety Vest (shown when wearingHardhat) */}
            {wearingHardhat && (
              <div className="safety-vest">
                <div className="vest-stripe vest-stripe-1"></div>
                <div className="vest-stripe vest-stripe-2"></div>
              </div>
            )}
          </div>

          {/* Arms */}
          <div className="arm arm-left">
            <div className="hand hand-left"></div>
          </div>
          <div className="arm arm-right">
            <div className="hand hand-right"></div>
          </div>

          {/* Legs */}
          <div className="leg leg-left">
            <div className="shoe shoe-left"></div>
          </div>
          <div className="leg leg-right">
            <div className="shoe shoe-right"></div>
          </div>

          {/* Sleep Z's (only visible in sleeping state) */}
          <div className="sleep-zs">
            <span className="z z1">z</span>
            <span className="z z2">Z</span>
            <span className="z z3">z</span>
          </div>

          {/* Sweat drops (for surprised/pushing) */}
          <div className="sweat-drops">
            <span className="sweat">💧</span>
          </div>
        </div>
      </div>
    );
  }
);

PixelDaniel.displayName = 'PixelDaniel';

export default PixelDaniel;
